export class Segments {
  public length: number;
  public index: string;
}
